import React from 'react';
import PropTypes from 'prop-types';
import CreditorsResultRow from './rows/CreditorsResultRow';
import FilersResultRow from './rows/FilersResultRow';
import AttorneysResultRow from './rows/AttorneysResultRow';
import AliasesResultRow from './rows/AliasesResultRow';
import HTMLResultRow from './rows/HTMLResultRow';
import ScheduleResultRow from './rows/ScheduleResultRow';
import AssociatedCasesResultRow from './rows/AssociatedCasesResultRow';
import TransactionsResultRow from './rows/TransactionsResultRow';
import StatusResultRow from './rows/StatusResultRow';
import PartiesResultRow from './rows/PartiesResultRow';
import DocketsResultRow from './rows/DocketsResultRow';
import ClaimsResultRow from './rows/ClaimsResultRow';
import EventsResultRow from './rows/EventsResultRow';
import DocketPopup from '../../case/docket/popups/DocketPopup';
import ResultsPaginator from './ResultsPaginator';

const entryTypes = {
  dockets: {
    label: 'Docket Entry',
    title: 'case docket',
    tab: 'docket',
    component: DocketsResultRow,
  },
  docket_headers: {
    label: 'Docket Header',
    title: 'case docket',
    tab: 'docket',
    component: HTMLResultRow,
  },
  claims: {
    label: 'Claim Entry',
    title: 'case claims',
    tab: 'claim',
    component: ClaimsResultRow,
  },
  claim_headers: {
    label: 'Claim Header',
    title: 'case claims',
    tab: 'claim',
    component: HTMLResultRow,
  },
  creditors: {
    label: 'Creditor Entry',
    title: 'case creditors',
    component: CreditorsResultRow,
  },
  attorneys: {
    label: 'Attorney',
    title: 'case attorneys',
    component: AttorneysResultRow,
  },
  history: {
    label: 'Events Entry',
    title: 'case events',
    component: EventsResultRow,
  },
  alias: {
    label: 'Party Alias',
    title: 'party aliases',
    component: AliasesResultRow,
  },
  associated_cases: {
    label: 'Associated Case',
    title: 'associated case listing',
    component: AssociatedCasesResultRow,
  },
  case_summary: {
    label: 'Case Summary',
    title: 'case summary',
    component: HTMLResultRow,
  },
  creditor_mailing: {
    label: 'Creditor Mailing Matrix',
    title: 'creditor mailing matrix',
    component: HTMLResultRow,
  },
  schedule: {
    label: 'Schedule Entry',
    title: 'case schedule',
    component: ScheduleResultRow,
  },
  filers: {
    label: 'Filer Entry',
    title: 'case filers',
    component: FilersResultRow,
  },
  notice: {
    label: 'Notice',
    title: 'case notice',
    component: HTMLResultRow,
  },
  parties: {
    label: 'Party Entry',
    title: 'party entries',
    component: PartiesResultRow,
  },
  related_transactions: {
    label: 'Related Transaction',
    title: 'related transaction',
    component: TransactionsResultRow,
  },
  status_pending: {
    label: 'Status',
    title: 'case status',
    component: StatusResultRow,
  },
  written_opinions: {
    label: 'Written Opinions',
    title: 'case',
    component: EventsResultRow,
  },
  case_headers: {
    label: 'Case Header',
    title: 'case',
    component: () => null,
  },
};

export const RowHeader = ({ row }) => {
  const type = row.query || row.document_type.replace('_part', ''); // row.query.replace('_part', '');
  const case_url = `/rpc/legacy/case-menu-redirect/${row.case_court}/${row.case_no}`;

  return (
    <h3 className="result-item-header">
      {row.case_title}
      {' | '}
      <a href={case_url} title="Go to Case Query Menu" target="_blank">
        {row.case_no}
      </a>
      {' | '}
      {row.case_court}
      {' | '}
      Chp. {row.case_chapter}
      {' | '}
      {row.case.date_filed || row.date_filed || row.case.date_closed || row.date_closed}
      {' | '}
      <a
        href={`${case_url}?open_tab=${entryTypes[type].tab || type}`}
        title={`Go to ${entryTypes[type].title}`}
        target="_blank"
      >
        {entryTypes[type].label}
      </a>
    </h3>
  );
};

RowHeader.propTypes = {
  row: PropTypes.any.isRequired,
};

const EntriesResults = ({ data, filter, onSearch }) => (
  <div id="ir-search-search-premium-results">
    <h2>
      Results – {data.num_found} matches within {data.num_cases} cases
      <span className="ir-search-premium-reset">
        <a
          href=""
          className="active"
          onClick={e => {
            e.preventDefault();
            onSearch({ ...filter, grouped: true, page: 0 });
          }}
        >
          Display Matching Cases Only
        </a>
      </span>
    </h2>
    {data.results.map((row, idx) => {
      const type = row.query || row.document_type.replace('_part', ''); // row.query.replace('_part', '');
      const RowComponent = entryTypes[type].component;

      return (
        <div key={idx} className={`result-item result-item-${type}`}>
          <RowHeader row={row} />
          <div className="result-item-body">
            <RowComponent row={row} id={idx} />
          </div>
        </div>
      );
    })}
    <ResultsPaginator
      totalPages={data.page_count}
      selectedPage={filter.page + 1 || 1}
      onChangePage={page => onSearch({ ...filter, page })}
    />
    <div className="docket">
      <DocketPopup />
    </div>
  </div>
);

EntriesResults.propTypes = {
  data: PropTypes.any.isRequired,
  filter: PropTypes.any.isRequired,
  onSearch: PropTypes.any.isRequired,
};

export default EntriesResults;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/EntriesResults.jsx